import { SchedulingTypes } from "./schedulingTypes";

export const schedulingReducer = {
  resetSchedulingError: (state: SchedulingTypes) => {
    state.error = null;
  },
  resetSchedulingSuccess: (state: SchedulingTypes) => {
    state.success = null;
  },
  resetSchedulingMessage: (state: SchedulingTypes) => {
    state.message = null;
  },
  resetSchedulingStatusCode: (state: SchedulingTypes) => {
    state.statusCode = null;
  },
  resetSchedulingFetching: (state: SchedulingTypes) => {
    state.fetching = false;
  },
  resetSchedulingUserViewListing: (state: SchedulingTypes) => {
    state.schedulingUserViewListing = [];
  },
  resetSchedulingApprovedListing: (state: SchedulingTypes) => {
    state.employeeApprovedList = [];
  },
  resetSchedulingCommentListing: (state: SchedulingTypes) => {
    state.commentList = [];
  },
  resetSchedulingUserViewTotalCount: (state: SchedulingTypes) => {
    state.userViewListTotal = 0;
  },
  resetSchedulingApproveTotalCount: (state: SchedulingTypes) => {
    state.employeeAprrovedTotalCount = 0;
  },
  resetSchedulingPrevoiusHour: (state: SchedulingTypes) => {
    state.previousHours = 0;
    },
    resetManagerNewRequest: (state: SchedulingTypes) => {
        state.schedulingManagerViewNewRequestsListing= [];
  },
  resetManagerNewRequestCount: (state: SchedulingTypes) => {
   state.managerNewRequestCount=0
   },
   resetReEstimateDataList: (state: SchedulingTypes) => {
    state.reEstimateDataList = [];
  },
  resetReEstimateDataTotalCount: (state: SchedulingTypes) => {
    state.reEstimateDataTotalCount = 0;
  },
  resetCalendarData: (state: SchedulingTypes) => { 
    state.calendarData=[]
  },
  resetRequestView: (state: SchedulingTypes) => {
    state.requestView={}
  },
  resetDailyHours: (state: SchedulingTypes) => {
    state.dailyHours = {};
  },
  resetAllusersScheduleList: (state: SchedulingTypes) => {
    state.allusersScheduleList = [];
  },
  resetAllusersScheduleTotalCount: (state: SchedulingTypes) => {
    state.allusersScheduleTotalCount = 0;
  },
  resetAllClientScheduleList: (state: SchedulingTypes) => {
    state.allClientScheduleList = [];
  },
  resetAllClientScheduleTotalCount: (state: SchedulingTypes) => {
    state.allClientScheduleTotalCount = 0;
  },
  resetClientUserSchedulingList: (state: SchedulingTypes) => {
    state.clientUserSchedulingList = [];
  },
  resetClientUserSchedulingListTotal: (state: SchedulingTypes) => {
    state.clientUserSchedulingListTotal = 0;
  }, 
  resetClientJobSchedulingList: (state: SchedulingTypes) => {
    state.clientJobSchedulingList = [];
  },
  resetClientJobSchedulingTotal: (state: SchedulingTypes) => {
    state.clientJobSchedulingTotal = 0;
  },
  resetSingleJobScheduledHoursSum: (state: SchedulingTypes) => {
    state.singleJobScheduledHoursSum = 0;
  },
  resetJobScheduledHoursList: (state: SchedulingTypes) => {
    state.singleJobScheduledHoursList = [];
  },
  resetAllUserMappedToJobList: (state: SchedulingTypes) => {
    state.allUserMappedToJob=[];
  },
  resetUsersAvailabilityReportData: (state: SchedulingTypes) => {
    state.usersAvailabilityReportData=[];
  },
  resetUsersAvailabilityTotalCount: (state: SchedulingTypes) => {
    state.usersAvailabilityTotalCount=0;
  }
 
};